exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pr_publish[data-v-de2ce42c]:before{display:none}.pr_publish a[data-v-de2ce42c]{padding:0}.pr_publish.home-rounded[data-v-de2ce42c]{border-radius:0 0 20px 20px}.mobile_only .pr_publish[data-v-de2ce42c]{margin:0;border-radius:20px 0 0 0}.mobile_only .pr_publish img[data-v-de2ce42c]{width:100%}", ""]);

// exports
